export default __webpack_public_path__ + "static/img-nhs-platelet-supply-chain-96b625de5f65ada4b30f37045cb5bdf6.jpg";